import React from 'react';
import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background border-t">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Informations entreprise */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">
              [Nom de votre société]
            </h3>
            <p className="text-sm text-muted-foreground mb-2">
              Solution SaaS de gestion de stock et caisse
            </p>
            <p className="text-sm text-muted-foreground">
              [Adresse - À remplir]<br/>
              [Email - À remplir]<br/>
              [Téléphone - À remplir]
            </p>
          </div>

          {/* Pages légales */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">
              Pages légales
            </h3>
            <nav className="space-y-2">
              <Link 
                to="/legal/mentions" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Mentions légales
              </Link>
              <Link 
                to="/legal/privacy" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Politique de confidentialité
              </Link>
              <Link 
                to="/legal/terms" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Conditions d'utilisation
              </Link>
              <Link 
                to="/legal/sales" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Conditions de vente
              </Link>
              <Link 
                to="/legal/cookies" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Politique de cookies
              </Link>
              <Link 
                to="/legal/compliance" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Conformité logicielle
              </Link>
            </nav>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold text-foreground mb-4">
              Support
            </h3>
            <nav className="space-y-2">
              <a 
                href="mailto:[support@votredomaine.com]" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Nous contacter
              </a>
              <a 
                href="[URL FAQ]" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                FAQ
              </a>
              <a 
                href="[URL Documentation]" 
                className="block text-sm text-muted-foreground hover:text-foreground transition-colors"
              >
                Documentation
              </a>
            </nav>
          </div>
        </div>

        <Separator className="my-6" />
        
        <div className="flex flex-col md:flex-row justify-between items-center text-sm text-muted-foreground">
          <p>
            © {currentYear} [Nom de votre société]. Tous droits réservés.
          </p>
          <p className="mt-2 md:mt-0">
            Logiciel certifié NF 525 - Conforme à l'article 286 du CGI
          </p>
        </div>
      </div>
    </footer>
  );
};